/*  ========================================================================
    # Scripts - Accordion
    ========================================================================  */

/**
 * Accordion functionality.
 */
const Accordion = {
  cfg: {
    sections: document.querySelectorAll('.s-accordion'),
    classes: {
      entry: 's-accordion__entry',
      entryActive: 's-accordion__entry--active',
      heading: 's-accordion__entry-heading'
    }
  },

  /**
   * Handle keyboard navigation.
   */
  handleKeydown(event, buttons, currentIndex) {
    let targetIndex;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        targetIndex = currentIndex === buttons.length - 1 ? 0 : currentIndex + 1;
        buttons[targetIndex].focus();
        break;

      case 'ArrowUp':
        event.preventDefault();
        targetIndex = currentIndex === 0 ? buttons.length - 1 : currentIndex - 1;
        buttons[targetIndex].focus();
        break;
    }
  },

  /**
   * Toggle accordion entry.
   */
  toggleEntry(entry, button) {
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    entry.classList.toggle(this.cfg.classes.entryActive);
    button.setAttribute('aria-expanded', !isExpanded);
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.sections.length) {
      this.cfg.sections.forEach(section => {
        const buttons = section.querySelectorAll(`.${this.cfg.classes.heading}`);

        buttons.forEach((button, index) => {
          const entry = button.closest(`.${this.cfg.classes.entry}`);

          if (button) {
            button.addEventListener('click', () => {
              this.toggleEntry(entry, button);
            });

            button.addEventListener('keydown', event => {
              this.handleKeydown(event, buttons, index);
            });
          }
        });
      });
    }
  }
};

export default Accordion;
